import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpRequestService } from './shared/services/http-request-service';
import { RolePermissionsService } from './shared/services/role-permissions.service';
import { RequestUrls, SamlUrl } from './shared/api-urls';
import { Router } from '@angular/router';
import { UserInfoService } from './shared/services/userinfo.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Idle } from 'idlejs/dist';
import { CommonService } from './shared/services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    @ViewChild('logOutSession') content: any;
    @ViewChild('rolePermissions') roleErrorContent: any;
    title = 'devicemgt-ui';
    isLoggedIn = false;
    isReady = false;
    SamlUrls = SamlUrl;
    private modalRef?: NgbModalRef;

    constructor(
        public http: HttpClient,
        public httpService: HttpRequestService,
        public rolePermissions: RolePermissionsService,
        private router: Router,
        private userInfoService: UserInfoService,
        private modalService: NgbModal,
        private commonService: CommonService
    ) {
        this.loadConfig();
        this.listenRouting();
    }

    loadConfig() {
        const endpoint = document.location.origin;
        if (endpoint.includes('art-saas-devicemgt-ui:8089')) {
            this.httpService.setEndPoint('http://art-saas-devicemgt-api:8088/api/');
            this.getLoggedIn();
        } else if (endpoint.includes('localhost')) {
            this.http.get('./assets/dev-config.json').subscribe((data: any = {}) => {
                const api = data.api || {};
                const endpoint = `${api.protocol}//${api.host}/api/`;
                this.httpService.setEndPoint(endpoint);
                this.getLoggedIn();
            });
        } else {
            this.httpService.setEndPoint(endpoint + '/api/');
            this.getLoggedIn();
        }
    }

    getInstanceType(): string {
        const pageUrl = window.location.origin;
        if (pageUrl.includes('saasdev')) return 'dev';
        if (pageUrl.includes('saasqa')) return 'qa';
        if (pageUrl.includes('saasstaging')) return 'staging';
        if (pageUrl.includes('art-saas-devicemgt-ui:8089')) return 'local_docker';
        if (pageUrl.includes('local')) return 'local';
        return 'prod';
    }

    getLoggedIn() {
        if (window['samlTriggered']) return;
        this.httpService.http.get('loggedIn', { withCredentials: true }).subscribe({
            next: (data: any) => {
                this.isLoggedIn = data.isLoggedIn || false;
                sessionStorage.setItem('isLoggedIn', this.isLoggedIn.toString());
                window['samlTriggered'] = false;
                this.isReady = true;
                this.getUserDetails();
            },
            error: (err) => {
                if (err.status === 401 && document.visibilityState === 'visible' && !window['samlTriggered']) {
                    window['samlTriggered'] = true;
                    const key = this.getInstanceType();
                    this.isReady = true;
                    window.location.assign(this.SamlUrls[key + '_login']);
                }
            }
        });
    }

    rolesError: string = '';
    getUserDetails() {
        const request = {
            action: 'user-info',
            success: (data: any) => {
                if (!data) {
                    this.logout();
                    return;
                }
                data = data || {};
                data.userInfo = data.userInfo || {};
                data.userInfo.roles = data.userInfo.roles || [];
                if (data.userInfo.roles.length > 0) {
                    this.getRolePermissions(data.userInfo.roles);
                }
                this.userInfoService.setUserDetails(data);
                data.sessionInfo = data.sessionInfo || {};
                this.getIdealRTimepopup(data.sessionInfo.maxInactiveIntervalInSec);
            },
            error: (error?: any) => {
                this.showRoleError(error);
            }
        };
        this.httpService.getRequest(request);
    }

    logout() {
        localStorage.removeItem('isLoggedin');
        const key = this.getInstanceType();
        window.location.assign(this.SamlUrls[key + '_logout']);
    }

    getRolePermissions(data: Array<any>) {
        this.httpService.http.post(RequestUrls.roles['permissions'], { guidList: data }, { withCredentials: true })
            .subscribe(
                (values: any) => {
                    values = values || [];
                    if (values.length === 0) {
                        this.showRoleError();
                    }
                    this.rolePermissions.setRolePermissions(values);
                    const timeInterval = 2 * 60 * 1000;
                    if (this.rolePermissions.hasPermission('REGISTER_DEVICES.VIEW')) {
                        this.commonService.getRegistrationRequestCount();
                        setInterval(() => {
                            this.commonService.getRegistrationRequestCount();
                        }, timeInterval);
                    } else if (this.rolePermissions.hasPermission('ALERT_MESSAGES.VIEW')) {
                        //this.commonService.getAlertMessagesCount();
                        setInterval(() => {
                            // this.commonService.getAlertMessagesCount();
                        }, timeInterval);
                    } else if (this.rolePermissions.hasPermission('PROVISIONING_REQUESTS.VIEW')) {
                        this.commonService.getProvisioningRequestCount();
                        setInterval(() => {
                            this.commonService.getProvisioningRequestCount();
                        }, timeInterval);
                    }
                    // Routing after permissions
                    const location = window.location.href;
                    const routes = location.split('#');
                    if (routes.length > 1) {
                        if (routes[1] === "/") {
                            this.router.navigateByUrl('/home');
                        } else {
                            this.router.navigateByUrl(routes[1]);
                        }
                        this.httpService.setLogoutURL(this.SamlUrls[this.getInstanceType() + '_logout']);
                    }
                },
                (error: any) => {
                    this.showRoleError(error);
                }
            );
    }

    autoLogout: any;
    idle: any;
    getIdealRTimepopup(maxInactiveIntervalInSec: number) {
        const expTime = maxInactiveIntervalInSec / 1000;
        const popupshowTime = expTime * 800;
        const logoutTime = maxInactiveIntervalInSec - popupshowTime;
        this.idle = new Idle()
            .whenNotInteractive()
            .within(popupshowTime, 1000)
            .do(() => {
                this.modalRef = this.modalService.open(this.content);
                this.idle.stop();
                this.autoLogout = setTimeout(() => {
                    this.logout();
                }, (logoutTime * 800));
            })
            .start();
    }

    continue() {
        this.modalRef?.close();
        clearInterval(this.autoLogout);
        this.getUserDetails();
    }

    showRoleError(error?: any) {
        error = error || {};
        this.isLoggedIn = false;
        error.error = error.error || {};
        error.error.message = error.error.message || null;
        error.error[0] = error.error[0];
        this.rolesError = error.error[0] || error.error.message || 'No role permissions as of now, Please contact Administrator';
        this.modalRef = this.modalService.open(this.roleErrorContent);
        setTimeout(() => {
            this.logout();
        }, 10000);
    }

    breadcrumbList: Array<any> = [];
    listenRouting() {
        this.router.events.subscribe((router: any) => {
            const routerUrl = router.urlAfterRedirects;
            if (routerUrl && typeof routerUrl === 'string') {
                this.breadcrumbList.length = 0;
                const routerList = routerUrl.slice(1).split('/');
                routerList.forEach((route, index) => {
                    if (route) {
                        this.breadcrumbList.push({
                            name: route,
                            path: (index === 0) ? `/${route}` : `${this.breadcrumbList[index - 1].path}/${route}`
                        });
                    }
                });
                this.commonService.setBreadCrumbs(this.breadcrumbList);
            }
        });
    }

}   